import publicIp from 'public-ip';

const getClientIp = async () => {
  return await publicIp.v4();
};

export default getClientIp;
